/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CruiseDeploymentDiscoveryConfig = {
    type: CruiseDeploymentDiscoveryConfig.type;
};

export namespace CruiseDeploymentDiscoveryConfig {

    export enum type {
        CRUISE = 'cruise',
    }


}

